import { EndorsementStatus } from "@covertree/agent-portal-graphql";

import { EndorsementCardProps } from "./types";

export interface ActionMenuItem {
  label: string;
  color?: string;
  onClick: () => void;
}

type ActionHandlers = Pick<
  EndorsementCardProps,
  | "onUpdateEndorsement"
  | "onIssueEndorsement"
  | "onReviewIssue"
  | "onUwReview"
  | "onDiscard"
>;

export function buildEndorsementActions(
  status: EndorsementStatus,
  isSocotraNative: boolean,
  isExpiredPolicy: boolean,
  handlers: ActionHandlers
): ActionMenuItem[] {
  if (
    isSocotraNative ||
    isExpiredPolicy ||
    status === EndorsementStatus.Issued
  ) {
    return [];
  }

  const noop = () => {};
  const discard: ActionMenuItem = {
    label: "Discard",
    color: "error.main",
    onClick: handlers.onDiscard ?? noop,
  };

  switch (status) {
    case EndorsementStatus.InProgress:
      return [
        {
          label: "Update Endorsement",
          onClick: handlers.onUpdateEndorsement ?? noop,
        },
        discard,
      ];
    case EndorsementStatus.AwaitingApproval:
      return [
        {
          label: "View reason",
          onClick: handlers.onUwReview ?? noop,
        },
        discard,
      ];
    case EndorsementStatus.ReadyToIssue:
      return [
        {
          label: "Issue Endorsement",
          onClick: handlers.onIssueEndorsement ?? noop,
        },
        discard,
      ];
    case EndorsementStatus.PaymentFailed:
    case EndorsementStatus.IssuanceFailed:
    case EndorsementStatus.ErrorOccurred:
      return [
        {
          label: "Review Issue",
          onClick: handlers.onReviewIssue ?? noop,
        },
        discard,
      ];
    default:
      return [];
  }
}
